module.exports = __webpack_public_path__ + "img/eric.992a9597.jpeg";